var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoPublications = function SvgNoPublications(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.0236,
    cy: 83.2767,
    r: 82.6173,
    fill: "#FFE0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.043 124.3C118.043 125.261 117.264 126.04 116.303 126.04H46.7029C45.7419 126.04 44.9629 125.261 44.9629 124.3V51.2196C44.9629 50.2586 45.7419 49.4796 46.7029 49.4796H116.303C117.264 49.4796 118.043 50.2586 118.043 51.2196V124.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.301 49.4797H111.081V117.34C111.081 118.301 110.302 119.08 109.341 119.08H44.9609V124.3C44.9609 125.261 45.74 126.04 46.7009 126.04H116.301C117.262 126.04 118.041 125.261 118.041 124.3V51.2197C118.041 50.2588 117.262 49.4797 116.301 49.4797Z",
    fill: "#FFE0E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.3 46H46.7005C43.8175 46 41.4805 48.3371 41.4805 51.22V124.3C41.4805 127.183 43.8175 129.52 46.7005 129.52H116.3C119.183 129.52 121.52 127.183 121.52 124.3V51.22C121.52 48.3371 119.183 46 116.3 46ZM118.041 124.3C118.041 125.261 117.262 126.04 116.301 126.04H46.7014C45.7404 126.04 44.9614 125.261 44.9614 124.3V51.2197C44.9614 50.2587 45.7404 49.4797 46.7014 49.4797H116.301C117.262 49.4797 118.041 50.2587 118.041 51.2197V124.3Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3999 84.2803H76.2799C78.2019 84.2803 79.7599 82.7222 79.7599 80.8003V63.4003C79.7599 61.4783 78.2019 59.9203 76.2799 59.9203H55.3999C53.478 59.9203 51.9199 61.4783 51.9199 63.4003V80.8003C51.9199 82.7222 53.478 84.2803 55.3999 84.2803ZM55.4009 63.4H76.2809V80.8H55.4009V63.4Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.341 59.9203H88.4607C87.4997 59.9203 86.7207 60.6993 86.7207 61.6603C86.7207 62.6213 87.4997 63.4003 88.4607 63.4003H109.341C110.302 63.4003 111.081 62.6213 111.081 61.6603C111.081 60.6993 110.302 59.9203 109.341 59.9203Z",
    fill: "#FC628F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.341 70.3599H88.4607C87.4997 70.3599 86.7207 71.1389 86.7207 72.0999C86.7207 73.0608 87.4997 73.8398 88.4607 73.8398H109.341C110.302 73.8398 111.081 73.0608 111.081 72.0999C111.081 71.1389 110.302 70.3599 109.341 70.3599Z",
    fill: "#FC628F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.341 80.7999H88.4607C87.4997 80.7999 86.7207 81.579 86.7207 82.5399C86.7207 83.5009 87.4997 84.2799 88.4607 84.2799H109.341C110.302 84.2799 111.081 83.5009 111.081 82.5399C111.081 81.579 110.302 80.7999 109.341 80.7999Z",
    fill: "#FC628F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.34 91.2402H53.6599C52.6989 91.2402 51.9199 92.0193 51.9199 92.9802C51.9199 93.9412 52.6989 94.7202 53.6599 94.7202H109.34C110.301 94.7202 111.08 93.9412 111.08 92.9802C111.08 92.0193 110.301 91.2402 109.34 91.2402Z",
    fill: "#FC628F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.34 101.68H53.6599C52.6989 101.68 51.9199 102.459 51.9199 103.42C51.9199 104.381 52.6989 105.16 53.6599 105.16H109.34C110.301 105.16 111.08 104.381 111.08 103.42C111.08 102.459 110.301 101.68 109.34 101.68Z",
    fill: "#FC628F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.34 112.12H53.6599C52.6989 112.12 51.9199 112.899 51.9199 113.86C51.9199 114.821 52.6989 115.6 53.6599 115.6H109.34C110.301 115.6 111.08 114.821 111.08 113.86C111.08 112.899 110.301 112.12 109.34 112.12Z",
    fill: "#FC628F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.501 66.7997C112.528 66.7997 101.201 55.4725 101.201 41.4997C101.201 27.5269 112.528 16.1997 126.501 16.1997C140.474 16.1997 151.801 27.5269 151.801 41.4997C151.786 55.466 140.467 66.7841 126.501 66.7997Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.032 21.5703C149.904 31.6249 149.033 45.9728 140.004 55.0021C130.975 64.0313 116.627 64.9018 106.572 57.0304C112.575 64.7589 122.499 68.3276 132.049 66.191C141.599 64.0544 149.056 56.5966 151.193 47.047C153.33 37.4974 149.761 27.5727 142.032 21.5703Z",
    fill: "#FFE0E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.5 12.5C110.484 12.5 97.5 25.4837 97.5 41.5C97.5 57.5163 110.484 70.5 126.5 70.5C142.516 70.5 155.5 57.5163 155.5 41.5C155.5 33.8087 152.445 26.4325 147.006 20.9939C141.568 15.5553 134.191 12.5 126.5 12.5ZM126.501 66.7998C112.528 66.7998 101.201 55.4726 101.201 41.4998C101.201 27.527 112.528 16.1998 126.501 16.1998C140.474 16.1998 151.801 27.527 151.801 41.4998C151.785 55.4661 140.467 66.7841 126.501 66.7998Z",
    fill: "#FC628F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 125.402,
    y: 31.6005,
    width: 3.2,
    height: 13.2,
    fill: "#FC628F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125.402,
    y: 49.1997,
    width: 3.2,
    height: 3.2,
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoPublications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-publications.a5f530e67808d77398d983aa1757b552.svg";